import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    userName: localStorage.getItem('loggedinUser') || '',
    email: localStorage.getItem('email') || '',
    role: localStorage.getItem('role') || '',
    memberSince: '8/12/2020',
    pfp: localStorage.getItem('profileImagePath') || '',
    is2FAEnabled: false,
  }),

  actions: {
    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      this.userName = userName
      localStorage.setItem('loggedinUser', userName)
    },

    changeEmail(email: string) {
      this.email = email
      localStorage.setItem('email', email)
    },

    changeRole(role: string) {
      this.role = role
      localStorage.setItem('role', role)
    },

    changeProfileImage(path: string) {
      this.pfp = path
      localStorage.setItem('profileImagePath', path)
    },
  },
})
